module.exports = __webpack_public_path__ + "img/home-2.58aad64e.png";